<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Quiz Results</p>
      <button class="delete" aria-label="close" @click="close"></button>
    </header>
    <section class="modal-card-body">
      <div class="quiz-result">
        <div class="quiz-summary">
          <p>Final Score: {{ correctCount }} / {{ totalScenarios }}</p>
        </div>

        <QuizNavigation
          :currentIndex="-1"
          :total-items="totalScenarios"
          :results="results"
          :can-navigate-to-past="true"
          @navigate="reviewPuzzle"
        />

        <div class="board-previews">
          <div
            v-for="(result, index) in results"
            :key="index"
            :class="[
              'board-preview-item',
              {
                'is-success': result.status === 'correct',
                'is-danger': result.status === 'incorrect',
                'is-warning': result.status === 'skipped',
              },
            ]"
            @click="reviewPuzzle(index)"
            role="button"
          >
            <BoardSnapshot
              :pgn="result.answerPgn || result.pgn"
              :board-size="176"
            />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import QuizNavigation from "./QuizNavigation.vue";
import BoardSnapshot from "../explorer/molecules/BoardSnapshot.vue";

export default {
  name: "QuizResult",

  components: {
    QuizNavigation,
    BoardSnapshot,
  },

  props: {
    isActive: {
      type: Boolean,
      required: true,
    },
    results: {
      type: Array,
      required: true,
    },
    correctCount: {
      type: Number,
      required: true,
    },
    totalScenarios: {
      type: Number,
      required: true,
    },
  },

  methods: {
    close() {
      this.$emit("close");
    },

    exit() {
      this.$emit("exit");
    },

    restart() {
      this.$emit("restart");
    },

    reviewPuzzle(index) {
      this.$emit("review", index);
    },

    copyPgn(pgn) {
      navigator.clipboard
        .writeText(pgn)
        .then(() => {
          this.$buefy.toast.open({
            message: "PGN copied to clipboard",
            type: "is-success",
          });
        })
        .catch((err) => {
          console.error("Failed to copy PGN:", err);
          this.$buefy.toast.open({
            message: "Failed to copy PGN",
            type: "is-danger",
          });
        });
    },
  },
};
</script>

<style scoped>
.modal-card {
  width: 100%;
  max-width: 1160px; /* slightly less than modal width to account for padding */
}

.quiz-result {
  padding: 1rem;
}

.quiz-summary {
  margin-bottom: 1.5rem;
}

.board-previews {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: center;
  margin-bottom: 1.5rem;
}

.board-preview-item {
  flex: 0 0 calc(33.333% - 1rem);
  min-width: 200px;
  max-width: 200px;
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 4px solid transparent;
  border-radius: 8px;
  padding: 8px; /* Reduced padding to ensure board fits properly */
  cursor: pointer;
  transition: transform 0.2s ease;
  background: white;
}

.board-preview-item:hover {
  background-color: rgba(0, 209, 178, 0.05);
  box-shadow: 0 0 0 2px #34369e;
  transform: translateY(-2px);
}

.board-preview-item.is-success {
  border-color: #48c774;
}

.board-preview-item.is-danger {
  border-color: #f14668;
}

.board-preview-item.is-warning {
  border-color: #ffdd57;
}

.quiz-final-actions {
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
  width: 100%;
}
</style>
